import { ApiParams, prepareBaseListApiParams } from '@/api/helpers/apiHelpers';
import { getDepositAccountsApi } from '@/api/v1/organization/deposit-accounts/getDepositAccountsApi';
import { prepareResponse, throwResponseError } from '@/helpers/apiHelpers/responseHelpers';

export const loadDepositAccounts = async (params: ApiParams) => {
  const apiParams = prepareBaseListApiParams(params);

  try {
    const response = await getDepositAccountsApi(apiParams);

    return prepareResponse(response);
  } catch (e) {
    throwResponseError(e);
  }
};
